import { inject } from '@angular/core'
import { CanActivateFn } from '@angular/router'
import { AuthService } from './auth-service.js'

export const studioRoleGuard: CanActivateFn = async (route, state) => {
	const authService = inject(AuthService)
	const redirect = state.url
		? `?redirect=${encodeURIComponent('/studio' + state.url)}`
		: ''

	if (!(await authService.isLoggedIn())) {
		window.location.replace(`/studio/login${redirect}`)
		return false
	}

	if (!authService.hasSystemPermission('UseStudio')) {
		window.location.replace(`/studio/no-studio-access${redirect}`)
		return false
	}

	return true
}
